import { Controller } from '@hotwired/stimulus';
import { convertToCurrency } from './currency';

export default class extends Controller {
  static targets = ['investor', 'amount', 'fees', 'total'];

  update(event) {
    const { name, amount, commissionRate } = event.detail;
    const netAmount = commissionRate > 0 ? Math.round(amount / (1 + commissionRate / 100)) : amount;
    const fees = amount - netAmount;

    this.investorTarget.textContent = name || '—';
    this.amountTarget.textContent = convertToCurrency(netAmount);
    this.feesTarget.textContent = convertToCurrency(fees);
    this.totalTarget.textContent = convertToCurrency(amount);
  }
}
